import React, { FC } from 'react';

import getHoCNameFromWrappedComponent from '../../util/react/getHoCNameFromWrappedComponent';

import { WithIsActiveProps } from './withIsActive.types';

import IsActive from '.';

/**
 * @deprecated(reason: 'use useIsActive hook instead)'
 */
export function withIsActive<T extends WithIsActiveProps>(WrappedComponent: FC<T>): FC<Omit<T, 'isActive'>> {
  const WithIsActive: FC<Omit<T, 'isActive'>> = (props) => (
    <IsActive>{(isActive) => <WrappedComponent {...(props as T)} isActive={isActive} />}</IsActive>
  );
  WithIsActive.displayName = getHoCNameFromWrappedComponent(WrappedComponent, 'WithIsActive');

  return WithIsActive;
}
